import { CFormFeedback } from '@coreui/react-pro'
import CIcon from '@coreui/icons-react'
import { cilCloudUpload } from '@coreui/icons'
import React, { useRef, useState } from 'react'

export const SUPPORTED_IMAGE_FORMATS = ['image/jpeg', 'image/png', 'image/webp']
export const MAX_IMAGE_SIZE = 2 * 1024 * 1024 // 2MB

const ImageDropzone = ({ onChange, error, previewUrl }) => {
  const [isDragging, setIsDragging] = useState(false)
  const fileInputRef = useRef(null)

  const handleFile = (file) => {
    if (file) onChange(file)
  }

  const handleDrop = (event) => {
    event.preventDefault()
    setIsDragging(false)
    handleFile(event.dataTransfer.files?.[0])
  }

  return (
    <>
      <div
        className="border rounded d-flex flex-column align-items-center justify-content-center text-center p-4"
        style={{
          cursor: 'pointer',
          minHeight: 150,
          backgroundColor: isDragging ? '#f0f4ff' : undefined,
          borderStyle: 'dashed',
        }}
        onClick={() => fileInputRef.current?.click()}
        onDragOver={(e) => {
          e.preventDefault()
          setIsDragging(true)
        }}
        onDragLeave={() => setIsDragging(false)}
        onDrop={handleDrop}
      >
        <CIcon icon={cilCloudUpload} size="xl" className="text-primary mb-2" />
        <div>
          Drag and drop an image or <span className="text-primary">browse</span>
        </div>
        <div className="text-medium-emphasis small">JPG, PNG or WEBP up to 2MB</div>
        <input
          ref={fileInputRef}
          type="file"
          hidden
          accept="image/jpeg,image/png,image/webp"
          onChange={(event) => handleFile(event.target.files[0])}
        />
      </div>
      {error ? (
        <CFormFeedback invalid className="d-block">
          {error}
        </CFormFeedback>
      ) : null}
      {previewUrl && (
        <div className="mt-2">
          <img
            src={previewUrl}
            alt="New"
            width={80}
            height={80}
            style={{ objectFit: 'cover', borderRadius: 6 }}
          />
        </div>
      )}
    </>
  )
}

export default ImageDropzone
